function initFreeSamplesModal(idSuffix = '') {
  const t = window.SAMPLES_TRANSLATIONS || {
    choose_your: 'Choose your',
    first: 'first',
    second: 'second',
    fragrance: 'fragrance',
    add_to_cart: 'Add to cart'
  };

  const toggleBtn = document.getElementById(`toggle-samples${idSuffix}`);
  const modalOverlay = document.getElementById(`samples-modal-overlay${idSuffix}`);
  const closeBtn = document.getElementById(`close-modal${idSuffix}`);
  const womenGroup = document.getElementById(`samples-women${idSuffix}`);
  const menGroup = document.getElementById(`samples-men${idSuffix}`);
  const unisexGroup = document.getElementById(`samples-unisex${idSuffix}`);
  let addButton = document.getElementById(`add-samples-button${idSuffix}`);
  const samplesSection = document.getElementById(`samples-section${idSuffix}`);
  // [NOWE] globalny semafor na równoległe dodania (cart/drawer/kilka kart)
  if (typeof window.__samplesAddLock === 'undefined') {
    window.__samplesAddLock = false;
  }

  // [NOWE] helper: świeży koszyk (cache busting + no-store)
  async function freshCart() {
    return fetch(`/cart.js?ts=${Date.now()}`, { cache: 'no-store' }).then(r => r.json());
  }

  // [NOWE] helper: policz ŁĄCZNĄ ILOŚĆ próbek (po property _is_gift)
  function countSampleQty(cart) {
    return cart.items.reduce((sum, item) => {
      const isGift = item?.properties?._is_gift === "true";
      return sum + (isGift ? item.quantity : 0);
    }, 0);
  }

  if (!toggleBtn || !modalOverlay || !closeBtn || !addButton) return;
  if (addButton.dataset.initialized === 'true') return;
  addButton.dataset.initialized = 'true';

  let maxSamplesAllowed = 2;
  const selectedSamples = new Set();

  toggleBtn.addEventListener('click', async () => {
    selectedSamples.clear();
    modalOverlay.classList.add('open');
    document.body.classList.add('modal-open');

    try {
            const cart = await freshCart();
      const alreadyInCartQty = countSampleQty(cart);
      maxSamplesAllowed = 2;
      loadSamples(cart, alreadyInCartQty);

    } catch (err) {
      console.error(`[free-samples${idSuffix}] Błąd przy odświeżaniu koszyka po kliknięciu:`, err);
    }
  });

  closeBtn.addEventListener('click', () => {
    modalOverlay.classList.remove('open');
    document.body.classList.remove('modal-open');
  });

  modalOverlay.addEventListener('click', (event) => {
    const modalContent = document.getElementById(`samples-modal${idSuffix}`);
    if (!modalContent.contains(event.target)) {
      modalOverlay.classList.remove('open');
      document.body.classList.remove('modal-open');
    }
  });

    // [NOWE] po dodaniu próbek z innej instancji – odśwież stan i UI
  document.addEventListener('samples:add:done', () => {
    shouldShowSamplesSection();
  });


  function updateUI(remainingAllowed) {
    const remaining = remainingAllowed - selectedSamples.size;
    if (remaining === 2) {
      addButton.textContent = `${t.choose_your} ${t.first} ${t.fragrance}`;
    } else if (remaining === 1) {
      addButton.textContent = `${t.choose_your} ${t.second} ${t.fragrance}`;
    } else {
      addButton.textContent = `${t.add_to_cart}`;
    }

    addButton.disabled = remaining !== 0;
    addButton.classList.toggle('disabled', remaining !== 0);
  }

      async function shouldShowSamplesSection() {
    try {
      const cart = await freshCart();
      const alreadyInCartQty = countSampleQty(cart);

      if (alreadyInCartQty >= 2 || cart.total_price === 0) {
        if (samplesSection) samplesSection.style.display = 'none';
        return;
      }

      if (alreadyInCartQty === 1) {
        const span = toggleBtn.querySelector('span');
        if (span) span.textContent = `${t.choose_your} ${t.second} ${t.fragrance}`;
      }

      maxSamplesAllowed = 2;
      loadSamples(cart, alreadyInCartQty);
    } catch (err) {
      console.error(`[free-samples${idSuffix}] Błąd przy sprawdzaniu koszyka:`, err);
    }
  }


  async function loadSamples(cartData, alreadyInCart) {
    const cartVariantIds = cartData.items.map(item => item.variant_id);
    const res = await fetch('/collections/free-samples/products.json?limit=250');
    const data = await res.json();
    const sampleProducts = data.products.filter(p => p.tags.includes('free-sample'));

    womenGroup.innerHTML = '';
    menGroup.innerHTML = '';
    unisexGroup.innerHTML = '';

    let loadedSamples = 0;

    sampleProducts.forEach(p => {
      const variant = p.variants[0];
      if (!variant || !variant.available || cartVariantIds.includes(variant.id)) return;

      loadedSamples++;

      const div = document.createElement('div');
      div.className = 'sample-item';
      div.dataset.variantId = variant.id;

      const img = document.createElement('img');
      img.src = p.images[0]?.src || '';
      img.alt = p.title;

      const info = document.createElement('div');
      info.className = 'sample-info';
      info.textContent = p.title;

      const icon = document.createElement('div');
      icon.className = 'sample-check-icon';
      icon.innerHTML = `
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path d="M5 13l4 4L19 7" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      `;

      div.appendChild(img);
      div.appendChild(info);
      div.appendChild(icon);

      // 🔄 TAP vs SCROLL handling
      let startX = 0, startY = 0, isDragging = false;

      div.addEventListener('pointerdown', (e) => {
        startX = e.clientX;
        startY = e.clientY;
        isDragging = false;
      });

      div.addEventListener('pointermove', (e) => {
        const dx = Math.abs(e.clientX - startX);
        const dy = Math.abs(e.clientY - startY);
        if (dx > 5 || dy > 5) {
          isDragging = true;
        }
      });

      div.addEventListener('pointerup', (e) => {
        if (isDragging) return;

        e.preventDefault();
        e.stopPropagation();

        const id = parseInt(div.dataset.variantId);

        if (selectedSamples.has(id)) {
          selectedSamples.delete(id);
        } else {
          if (selectedSamples.size >= maxSamplesAllowed - alreadyInCart) return;
          selectedSamples.add(id);
        }

        document.querySelectorAll(`.sample-item`).forEach(el => {
          const vid = parseInt(el.dataset.variantId);
          const isSelected = selectedSamples.has(vid);
          el.classList.toggle('faded', !isSelected && selectedSamples.size >= maxSamplesAllowed - alreadyInCart);
          el.classList.toggle('selected', isSelected);
        });

        updateUI(maxSamplesAllowed - alreadyInCart);
      });

      if (p.tags.includes('free-sample-women')) {
        womenGroup.appendChild(div);
      } else if (p.tags.includes('free-sample-men')) {
        menGroup.appendChild(div);
      } else if (p.tags.includes('free-sample-unisex')) {
        unisexGroup.appendChild(div);
      }

      if (samplesSection) samplesSection.style.display = 'block';
    });

    if (loadedSamples === 0) {
      if (toggleBtn) toggleBtn.style.display = 'none';
      if (samplesSection) samplesSection.style.display = 'none';
      return;
    }

    const newAddButton = addButton.cloneNode(true);
    addButton.replaceWith(newAddButton);
    addButton = newAddButton;

       newAddButton.addEventListener('click', async () => {
      if (addButton.disabled) return;

      // [NOWE] globalny lock – chroni przed podwójnym „Dodaj” (drawer + cart / wiele kart)
      if (window.__samplesAddLock) return;
      window.__samplesAddLock = true;

      addButton.disabled = true;

      try {
        // ŚWIEŻY koszyk tuż przed wysyłką (minimalizuje wyścigi)
        const cart = await freshCart();

        const alreadyInCartQty = countSampleQty(cart);
        const remaining = Math.max(0, maxSamplesAllowed - alreadyInCartQty);

        if (remaining <= 0) {
          alert("Dodałeś już maksymalną liczbę darmowych próbek.");
          return;
        }

        if (selectedSamples.size > remaining) {
          alert(`Możesz dodać tylko ${remaining} próbkę/próbki.`);
          return;
        }

        const items = [...selectedSamples].slice(0, remaining).map(id => ({
          id: id,
          quantity: 1,
          properties: { 
      _is_gift: "true",
      _gift_type: "sample"
    }
        }));

        if (!items.length) return;

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items })
        });

        if (!response.ok) {
          const errText = await response.text();
          console.error(`[free-samples${idSuffix}] Błąd Shopify:`, errText);
          alert("Nie udało się dodać próbki.");
          return;
        }

        modalOverlay.classList.remove('open');
        document.body.classList.remove('modal-open');

        // odśwież koszyk i powiadom inne instancje
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('samples:add:done', { bubbles: true }));

        if (idSuffix === '-drawer') {
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && typeof cartDrawer.show === 'function') {
            cartDrawer.show();
          }
        } else if (window.location.pathname === '/cart') {
          location.reload();
        }

      } catch (error) {
        console.warn(`[free-samples${idSuffix}] Błąd techniczny po kliknięciu:`, error);
        alert("Wystąpił błąd techniczny.");
      } finally {
        addButton.disabled = false;
        window.__samplesAddLock = false;
      }
    });


    updateUI(maxSamplesAllowed - alreadyInCart);
  }

  shouldShowSamplesSection();
}

document.addEventListener('DOMContentLoaded', () => {
  initFreeSamplesModal('-cart');
  initFreeSamplesModal('-drawer');
});

document.addEventListener('cart-drawer:refreshed', () => {
  initFreeSamplesModal('-drawer');
});
